import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type D1TimeSerie, columns } from "./columns";
import { type FilterD1TimeSeriesSchema, FilterD1TimeSeries } from "./filter";

export const D1TimeSeriesTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<D1TimeSerie>({
    client: Clients.D1,
    table_name: Tables.D1_TIME_SERIES,
    resourceLabel: "Valorisation",
  });

  return (
    <>
      <Table<D1TimeSerie, FilterD1TimeSeriesSchema>
        label="Valorisation"
        client={Clients.D1}
        table_name={Tables.D1_TIME_SERIES}
        columns={columns}
        filter={<FilterD1TimeSeries />}
        actions={[
          {
            label: "actions.new",
            route: `${Clients.D1}/${Tables.D1_TIME_SERIES}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
